var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_179",
    "data-name": "Rect\\xE1ngulo 179",
    width: 22,
    height: 22,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_7",
    "data-name": "Enmascarar grupo 7",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_search_",
    "data-name": "FontAwsome (search)",
    d: "M16.3,14.287,13.08,11.07a.774.774,0,0,0-.549-.226h-.526a6.71,6.71,0,1,0-1.162,1.162v.526a.774.774,0,0,0,.226.549L14.287,16.3a.771.771,0,0,0,1.094,0l.913-.913A.778.778,0,0,0,16.3,14.287ZM6.713,10.844a4.131,4.131,0,1,1,4.131-4.131A4.129,4.129,0,0,1,6.713,10.844Z",
    transform: "translate(2.588 2.588)",
    fill: "#bfbfbf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchInactive);
export default __webpack_public_path__ + "static/media/icon_search_inactive.825f5c84086ee6c8cf5a8f3eb3ae09e7.svg";
export { ForwardRef as ReactComponent };